<template lang="pug">
    .article(:class="{ highlight: qty > 0}")
        fieldset(:disabled="!article")
            .field.is-grouped
                button.button.is-primary.is-small.decrease(@click="decrease" :disabled="! qty || qty <= 0")
                    span.icon
                        i.fas.fa-minus
                input.input.qty.is-small(type="number" min="0" max="1000" step="1" v-model="qty")
                button.button.is-primary.is-small.increase(@click="increase" :disabled="qty >= 1000")
                    span.icon
                        i.fas.fa-plus
        fieldset.summary(v-if="article && qty" disabled)
            .field.has-text-right {{ price }}
</template>

<script>

import { cloneDeep, each, debounce, get } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { moneyFormat, findPrice } from '@/filters'

export default {
    name: "Article",
    props: {
        article: {
            type: [Object, Boolean],
            required: true,
        },
        product: {
            type: Object,
            required: true,
        },
    },
    computed: {
        // tax() {
        //     return ((100 + this.defaultTax.value) / 100)
        // },
        price() {
            const price =
                findPrice(this.article, this.customer, this.defaultCustomerGroup, true) ||
                findPrice(this.product, this.customer, this.defaultCustomerGroup, true);

            const taxRate = _.get(price, 'tax.value') || this.defaultTax.value;
            const tax = _.round((price.value * taxRate) / (100 + taxRate), 2);

            const qty = this.qty || 0

            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'
            return moneyFormat((price.value - tax) * qty, code)
        },
        qty: {
            get() {
                const articles = _.get(this.cart, 'articles') || [];

                // console.log(articles);

                const article = articles.find(el => el.id === this.article.id)

                let qty
                if (article) qty = article.qty

                return qty > 0 ? qty : undefined
            },
            set(qty) {
                let article = cloneDeep(this.article)
                article.product = cloneDeep(this.product)
                delete article.product.articles
                this.updateArticleQtyInArticle({ article, qty })
            }
        },
        ...mapGetters({
            cart: 'shop/cart',
            customer: 'shop/customer',
            defaultCustomerGroup: 'defaultCustomerGroup',
            defaultTax: 'defaultTax',
        })
    },
    methods: {
        round(value, decimals = 2) {
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        },
        increase() {
            let article = cloneDeep(this.article)
            article.product = cloneDeep(this.product)
            delete article.product.articles
            this.addArticleToCart(article)
        },
        decrease() {
            if (this.qty && this.qty > 0) {
                let article = cloneDeep(this.article)
                article.product = cloneDeep(this.product)
                delete article.product.articles
                this.removeArticleFromCart(article)
            }
        },
        ...mapActions({
            addArticleToCart: 'shop/addArticleToCart',
            removeArticleFromCart: 'shop/removeArticleFromCart',
            updateArticleQtyInArticle: 'shop/updateArticleQtyInArticle',
        })
    },
    // mounted(){
    //     this.amount = this.theAmount
    // }
}
</script>
<style lang="sass" scoped>

    @import '~@/assets/sass/variables';

    .control
        margin: 0!important
        .is-50
            max-width: 50%
        .is-25
            max-width: 25%
    .decrease
        border-radius: $radius
        border-top-right-radius: 0
        border-bottom-right-radius: 0
    .increase
        border-radius: $radius
        border-top-left-radius: 0
        border-bottom-left-radius: 0
    .input
        max-width: 100%
        text-align: right
        border-radius: 0
        &.qty
            text-align: center
            color: rgba(100,100,100, .4)
            -moz-appearance: textfield
            &::-webkit-inner-spin-button, ::-webkit-outer-spin-button
                -webkit-appearance: none
                margin: 0
    button.button
        max-width: 25%

    .summary
        margin-top: 10px
        .input
            opacity: .3
            background: none
            border: none
            font-weight: bold
            transition: opacity .15s ease
    .article.highlight
        .summary .input
            opacity: 1
        .input.qty
            color: #7a7a7a
            font-weight: bold
</style>
